import { GetServerSideProps } from 'next'
import { Box, Button, Heading, NameValueList, NameValuePair } from 'grommet'
import { useTranslation } from 'react-i18next'

import { formatDate } from 'util/date'
import useDeviceSize from 'hooks/useDevice'
import Layout from 'components/layout/Layout'
import LogoBox from 'components/pricing/LogoBox'
import { CommonPageProps, createPage } from 'util/ssp'
import usePlanSubscription from 'hooks/usePlanSubscription'
import SubscriptionPlans from 'components/pricing/SubscriptionPlans'

type Props = CommonPageProps
export const getServerSideProps: GetServerSideProps = async function (ctx) {
  return await createPage<Props>(ctx, {})
}

export default function Pricing(): JSX.Element {
  const { t } = useTranslation()
  const { small, medium } = useDeviceSize()
  const { subscription } = usePlanSubscription()
  return (
    <Layout title={t('pages.pricing.title')} justify="start">
      <Box
        width={small ? '100%' : { min: '60vw', max: medium ? '100vw' : '80vw' }}
        margin={{ bottom: 'xlarge' }}>
        {subscription ? (
          <Box width="medium" margin="0 auto" direction="column" gap="small" justify="center">
            <Heading textAlign="center" fill size="2.5rem">
              {t('Your subscription')}
            </Heading>
            <NameValueList valueProps={{ align: 'end' }}>
              <NameValuePair name="Status:">
                <>{subscription.status}</>
              </NameValuePair>
              <NameValuePair name="Amount:">
                <>
                  {subscription.currency} {subscription.unit_price}
                </>
              </NameValuePair>
              {subscription.next_bill_date && (
                <NameValuePair name="Next Billing Date:">
                  <>{formatDate(new Date(subscription.next_bill_date))}</>
                </NameValuePair>
              )}
            </NameValueList>
            {subscription.update_url && (
              <Button
                primary
                target="_blank"
                href={subscription.update_url}
                label={t('cta.manage-subscription')}
              />
            )}
            {subscription.cancel_url && (
              <Button
                primary
                target="_blank"
                color="status-warning"
                href={subscription.cancel_url}
                label={t('cta.cancel-subscription')}
              />
            )}
          </Box>
        ) : (
          <SubscriptionPlans />
        )}

        <Box margin={{ top: 'xlarge' }}>
          <LogoBox />
        </Box>
      </Box>
    </Layout>
  )
}
